import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../Components/Navbar";
import View from "../Components/View";
import Apropos from "../Components/Apropos";
import Footer from "../Components/Footer";

function Home() {
  return (
    <div className="home-section">
      <Helmet>
        <title>Balagne Medical Service</title>
        <meta
          name="description"
          content="Spécialiste de la location et de la vente de matériel médical en Corse : particuliers et professionnels."
        />
        <link rel="canonical" href="https://www.balagnemedical.com/" />
      </Helmet>

      <Navbar />
      <View />
      <Apropos />
      <Footer />
    </div>
  );
}

export default Home;
